import { Injectable } from '@angular/core';
import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, retry, timer } from 'rxjs';

const defaultRetryInterval = 5_000;
const defaultMaxRetryCount = 5;

export const RETRY_INTERVAL = new HttpContextToken<number>(() => defaultRetryInterval);
export const MAX_RETRY_COUNT = new HttpContextToken<number>(() => defaultMaxRetryCount);

const backoffRetry =
  <T>(count: number, delay: number) =>
  (obs$: Observable<T>) =>
    obs$.pipe(
      retry({
        count,
        delay: (_, retryIndex) => timer(Math.pow(2, retryIndex - 1) * delay)
      })
    );

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method !== 'GET') {
      return next.handle(req);
    }

    const retryInterval = req.context.get(RETRY_INTERVAL) ?? defaultRetryInterval;
    const maxRetryCount = req.context.get(MAX_RETRY_COUNT) ?? defaultMaxRetryCount;
    return next.handle(req).pipe(backoffRetry(maxRetryCount, retryInterval));
  }
}
